var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheelchairAccessible = function SvgWheelchairAccessible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 19.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M3.79 8.504a6.5 6.5 0 1 0 8.534 9.464m6.276.132-.677.226a1 1 0 0 1-1.21-.502l-2.06-4.118a2 2 0 0 0-1.79-1.106H10.27a2 2 0 0 1-1.968-1.642L7.691 7.6m0 0H12.6m-4.91 0-.363-2m.023-4.5a.5.5 0 0 1-1 0m1 0a.5.5 0 0 0-1 0m1 0h-1"
  })));
};
export default SvgWheelchairAccessible;